import { React, useContext, useState } from 'react'
import { CButton, CModal, CModalBody, CRow, CCard } from '@coreui/react'
import { isEmpty } from 'lodash'
import { AppContext } from 'src/views/context/app'
import PremiumIcon from '../../assets/premium-icon.svg'

const AddSectionModal = ({ data, onCancel, onAdd }) => {
  const { accountObj } = useContext(AppContext)
  const [category, setCategory] = useState('all')
  const [selectedComponent, setSelectedComponent] = useState({ _id: '' })

  const premiumComponent = (componentId) => {
    return !isEmpty(accountObj?.allowed_components)
      ? !accountObj?.allowed_components.includes(componentId)
      : true
  }

  const handleCategorySelect = (cat) => {
    setCategory(cat)
  }
  const handleComponentSelect = (info) => {
    setSelectedComponent(info)
  }
  const handleAddComponent = (info) => {
    if (selectedComponent?._id) {
      onAdd(selectedComponent)
      onCancel()
    }
  }

  const isDisabled = (category) => {
    let arr = data.filter((info) => info?.data?.category.includes(category))
    return isEmpty(arr)
  }

  return (
    <CModal size="xl" visible={true} alignment="center" className="add-section-modal border-0">
      <CModalBody
        className="m-auto p-0 w-100"
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          height: '41vw',
        }}
      >
        <div style={{ width: '23%', background: '#e1e1e1', color: '#171717' }} className="">
          <div className="w-100" style={{ padding: '20.7% 0px 0px 24.7%' }}>
            <p style={{ fontSize: '1.25vw' }}>ADD NEW SECTION</p>
            <div style={{ fontSize: '1.04vw' }} className="mt-5">
              <p
                style={{ fontWeight: category === 'all' ? '500' : '' }}
                className={`${
                  category === 'all' && 'selected-text-underline '
                } cursor-pointer mb-3`}
                onClick={() => handleCategorySelect('all')}
              >
                All Sections
              </p>
              <p
                style={{ fontWeight: category === 'promotion' ? '500' : '' }}
                className={`${
                  category === 'promotion' && 'selected-text-underline '
                } cursor-pointer mb-3`}
                onClick={() => handleCategorySelect('promotion')}
              >
                Ad/Promotional Space
              </p>
              <p
                style={{ fontWeight: category === 'banner_carousel' ? '500' : '' }}
                className={`${
                  category === 'banner_carousel' && 'selected-text-underline '
                } cursor-pointer mb-3`}
                onClick={() => handleCategorySelect('banner_carousel')}
              >
                Banner carousel
              </p>
              <p
                style={{ fontWeight: category === 'card_carousel' ? '500' : '' }}
                className={`${
                  category === 'card_carousel' && 'selected-text-underline '
                } cursor-pointer mb-3`}
                onClick={() => handleCategorySelect('card_carousel')}
              >
                Card Carousel
              </p>
              <p
                style={{ fontWeight: category === 'category_list' ? '500' : '' }}
                className={`${
                  category === 'category_list' && 'selected-text-underline '
                } cursor-pointer mb-3`}
                onClick={() => handleCategorySelect('category_list')}
              >
                Category List
              </p>
              <p
                style={{
                  fontWeight: category === 'footer' ? '500' : '',
                  color: isDisabled('footer') ? '#a1a1a1' : '',
                  cursor: isDisabled('footer') ? 'default' : 'pointer',
                }}
                className={`${category === 'footer' && 'selected-text-underline '} mb-3`}
                onClick={isDisabled('footer') ? null : () => handleCategorySelect('footer')}
              >
                Footer
              </p>
              <p
                style={{ fontWeight: category === 'group_carousel' ? '500' : '' }}
                className={`${
                  category === 'group_carousel' && 'selected-text-underline '
                } cursor-pointer mb-3`}
                onClick={() => handleCategorySelect('group_carousel')}
              >
                Group Carousel
              </p>
              <p
                style={{
                  fontWeight: category === 'header' ? '500' : '',
                  color: isDisabled('header') ? '#a1a1a1' : '',
                  cursor: isDisabled('header') ? 'default' : 'pointer',
                }}
                className={`${category === 'header' && 'selected-text-underline '} mb-3`}
                onClick={isDisabled('header') ? null : () => handleCategorySelect('header')}
              >
                Header
              </p>
              <p
                style={{ fontWeight: category === 'static_cards' ? '500' : '' }}
                className={`${
                  category === 'static_cards' && 'selected-text-underline '
                } cursor-pointer mb-3`}
                onClick={() => handleCategorySelect('static_cards')}
              >
                Static Cards
              </p>
              <p
                style={{ fontWeight: category === 'testimonial' ? '500' : '' }}
                className={`${
                  category === 'testimonial' && 'selected-text-underline '
                } cursor-pointer`}
                onClick={() => handleCategorySelect('testimonial')}
              >
                Testimonial
              </p>
            </div>
          </div>
        </div>
        <div style={{ width: '77%' }} className="">
          <div
            className="w-100 static-scrollbar-class"
            style={{ marginTop: '6.2% ', height: '80%', padding: '0% 4%' }}
          >
            <CRow className=" w-100 flex justify-between" xs={{ cols: 2, gutterY: 5, gutterX: 0 }}>
              {data
                .filter((info) => category === 'all' || info?.data?.category.includes(category))
                .map((info, index) => {
                  const isPremiumComponent = premiumComponent(info?._id)
                  return (
                    <div
                      style={{ width: '45.6%' }}
                      key={index}
                      className="d-flex flex-column justify-center align-items-center"
                    >
                      <CCard
                        style={{
                          border: info._id === selectedComponent._id ? '2px solid #2172eb' : '',
                        }}
                        className={`add-section-card w-100 flex justify-center items-center cursor-pointer ${
                          isPremiumComponent && 'premium-component-overlay'
                        }`}
                        onClick={() => handleComponentSelect(info)}
                      >
                        <div className="premium-component-text position-absolute w-100 h-100 d-flex justify-content-center align-items-center">
                          <div
                            style={{
                              borderTop: '1px solid white',
                              borderBottom: '1px solid white',
                            }}
                            className="text-white py-1"
                          >
                            <p style={{ fontSize: '0.729vw', fontWeight: '550' }} className="mb-0">
                              PREMIUM COMPONENT
                            </p>
                          </div>
                        </div>
                        <img
                          src={info?.preview_s3_key?.website}
                          style={{ maxHeight: '100%', maxWidth: '100%' }}
                          className=""
                          alt="preview_s3_key"
                        />
                      </CCard>
                      <span
                        style={{ fontSize: '1.04vw', fontWeight: '450' }}
                        className="mt-2 d-flex align-items-center"
                      >
                        {info?.component_name}
                        {isPremiumComponent && (
                          <img
                            src={PremiumIcon}
                            style={{ width: '1.25vw', height: '1.25vw' }}
                            className="ml-2"
                            title="Premium Component"
                          />
                        )}
                      </span>
                    </div>
                  )
                })}
            </CRow>
          </div>
          <div style={{ marginRight: '7%' }} className="mt-3 d-flex justify-content-end">
            <CButton
              style={{ color: 'black', border: '1px solid black' }}
              className="mx-4 bg-white rounded-1 btn-focus-none"
              onClick={onCancel}
            >
              Cancel
            </CButton>
            <CButton className=" bg-black rounded-1 btn-focus-none" onClick={handleAddComponent}>
              Add to Template
            </CButton>
          </div>
        </div>
      </CModalBody>
    </CModal>
  )
}

export default AddSectionModal
